import { render, staticRenderFns } from "./User-grade-detail.vue?vue&type=template&id=0a554e7c&scoped=true&"
import script from "./User-grade-detail.vue?vue&type=script&lang=js&"
export * from "./User-grade-detail.vue?vue&type=script&lang=js&"
import style0 from "./User-grade-detail.vue?vue&type=style&index=0&id=0a554e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a554e7c",
  null
  
)

export default component.exports